<template>
  <div class="menu-wrapper">
    <template v-for="item in routes">
      <el-submenu :index="item.title" :key="item.name" v-if="item.children && item.children.length > 0">
        <template slot="title">
          <icon-svg v-if="item.icon" :icon-class="item.icon"></icon-svg>
          <span>{{ item.title }}</span>
        </template>
        <template v-for="child in item.children">
          <template v-if="!hiddenItem.includes(child.code)">
            <sidebar-item
              class="nest-menu"
              v-if="child.children && child.children.length > 0"
              :routes="[child]"
              :key="child.name"
            >
            </sidebar-item>
            <a
              target="_blank"
              v-if="child.href != null && child.href.indexOf('http') == 0"
              :href="child.href"
              :key="child.name"
            >
              <el-menu-item :index="'/' + item.code + '/' + child.code">
                <icon-svg v-if="child.icon" :icon-class="child.icon"></icon-svg>
                <span>{{ child.title }}</span>
              </el-menu-item>
            </a>
            <router-link
              v-if="child.href != null && child.href.indexOf('http') != 0 && child.type != 'dirt'"
              :to="'/' + item.code + '/' + child.code"
              :key="child.name"
            >
              <el-menu-item
                :index="'/' + item.code + '/' + child.code"
                :class="{ 'menu-group-start': isGroupStart(child.code) }"
              >
                <icon-svg v-if="child.icon" :icon-class="child.icon"></icon-svg>
                <span>{{ child.title }}</span>
              </el-menu-item>
            </router-link>
          </template>
        </template>
      </el-submenu>
      <template v-else>
        <a
          target="_blank"
          v-if="item.href != null && item.href.indexOf('http') == 0"
          :href="item.href"
          :key="item.name"
        >
          <el-menu-item :class="isCollapse ? 'demo' : ''" :index="'/' + item.code">
            <icon-svg v-if="item.icon" :icon-class="item.icon"></icon-svg>
            <span>{{ item.title }}</span>
          </el-menu-item>
        </a>
        <router-link
          v-if="item.href != null && item.href.indexOf('http') != 0 && item.type != 'dirt'"
          :to="'/' + item.href"
          :key="item.name"
        >
          <el-menu-item :class="isCollapse ? 'demo2' : ''" :index="'/' + item.href">
            <icon-svg v-if="item.icon" :icon-class="item.icon"></icon-svg>
            <span v-if="item.title.indexOf('CRM') != 0">{{ item.title }}</span>
          </el-menu-item>
        </router-link>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

/**
 * 二级菜单分组：数组里放「每个分组第一项」的 code，渲染到这一项时在它上方画一条分隔线。
 * 不在这里的菜单不受任何影响，照常渲染。
 *
 * 本来想把组名存在 base_menu.attr1/attr2 里，但后端菜单接口的 VO 只返回
 * id/parentId/children/icon/title/href/spread/path/code/type，不带 attr 字段，
 * 要用就得改 crm-admin 的 VO，多发一个仓库。菜单分组本身不常变，先放前端。
 */
const MENU_GROUP_START = [
  /* 推广付款：基础配置 | 测评推广 | 其他推广 */
  'reimbersementManager',      // 测评上报——测评推广这一组的开头
  'promoteItemDetailManager'   // 其他上报——其他推广这一组的开头
];

export default {
  name: 'SidebarItem',
  data() {
    return {
      isOpened: undefined,
      hiddenItem: [
        'mails-detail',
        'pullRecord',
        'add-template',
        'other-report',
        'kol-detail',
        'kol-info-detail',
        'edit-forecast',
        'history-forecast',
        'store-detail',
        'period-detail',
        'budget-detail',
        'supply-detail',
        'reimbersementProcessAppManager',
        'itemProcessAppManager'
      ]
    };
  },
  props: {
    routes: {
      type: Array
    }
  },
  computed: {
    ...mapGetters(['sidebar']),

    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  methods: {
    /**
     * 这一项是不是某个分组的开头
     * @param {String} code 菜单 code
     * @return {Boolean} true 则在它上方画分隔线
     */
    isGroupStart(code) {
      return MENU_GROUP_START.indexOf(code) > -1;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" slot-scope>
.demo,
.demo2 {
  padding: 0 !important;
  .svg-icon {
    margin: 0 0 0 10px !important;
  }
}
.demo {
  overflow: hidden;
  .svg-icon {
    margin-right: 16px !important;
  }
}
</style>
